<template>
  <v-row>
    <v-col cols="12" v-for="risk in unitProfileStore.selectedUnitProfile.risks">
    <UnitProfileFlagWidget :risk="risk" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import UnitProfileFlagWidget from "@/views/unit-profile/UnitProfileFlagWidget.vue";
import { useUnitProfileStore } from "@/stores/unitProfileStore";

const unitProfileStore = useUnitProfileStore();

</script>